import React, { useState, useEffect } from "react";
import Image from 'next/future/image'
import { motion, AnimatePresence } from "framer-motion";
import TestimonialsStyles from "@components/SmallBusinessTaxesPage/TestimonialsStyles";
import { useInterval, useWindow } from "@helpers/hooks";
import PropTypes from "prop-types";

const variants = {
  enter: ({ viewPort, direction }) => {
    return {
      translateX: direction > 0 ? '100%' : '-100%',
      translateY: viewPort < 768 ? '0%' : '20%',
      opacity: 0,
    };
  },
  center: {
    zIndex: 1,
    translateX: '-50%',
    translateY: '0%',
    opacity: 1,
  },
  exit: ({ viewPort, direction }) => {
    return {
      zIndex: 0,
      translateX: direction < 0 ? '100%' : '-100%',
      translateY: viewPort < 768 ? '0%' : '20%',
      opacity: 0
    };
  }
};

const Testimonials = ({ items, isPayroll }) => {
  const [direction, setDirection] = useState(1);
  const [index, setIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(null)
  const [touchEnd, setTouchEnd] = useState(null)
  const viewPort = useWindow();

  const syncHeight = () => {

    const box = document.querySelectorAll(`${TestimonialsStyles} .slider-container`);
    const boxHeight = Math.max(...[...box].map(b => b.offsetHeight));
    const container = document.getElementById('testimonial-small-business');
    container.style.height = `${boxHeight}px`;
  };

  useInterval(() => changeIndex(index + 1), 7000);
  useEffect(() => syncHeight(), [viewPort]);

  const changeIndex = (newIndex) => {
    const indexValue = newIndex % items.length;
    setDirection(index > indexValue ? -1 : 1);
    setIndex(indexValue);
  };

  const onTouchStart = (e) => {
    setTouchEnd(null) // otherwise the swipe is fired even with usual touch events
    setTouchStart(e.targetTouches[0].clientX)
  }

  const onTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX)

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return
    const minSwipeDistance = 50  // the required distance between touchStart and touchEnd to be detected as a swipe
    const distance = touchStart - touchEnd
    const isLeftSwipe = distance > minSwipeDistance
    const isRightSwipe = distance < -minSwipeDistance
    const itemsLength = items.length

    if (isRightSwipe) {
      setIndex(prevIndex => {
        if (prevIndex === 0) {
          return itemsLength - 1
        }
        else {
          return prevIndex - 1
        }
      })
      setDirection(-1)
    }
    else if (isLeftSwipe) {
      setIndex(prevIndex => {
        if (prevIndex === itemsLength - 1) {
          return 0
        }
        else {
          return prevIndex + 1
        }
      })
      setDirection(1)
    }
  }

  return (
    <TestimonialsStyles>
      <AnimatePresence initial={false} custom={{ viewPort, direction }}>
        <motion.div
          onAnimationStart={() => syncHeight()}
          onAnimationComplete={() => syncHeight()}
          className={`slider-container`}
          key={index}
          custom={{ viewPort, direction }}
          variants={variants}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{
            translateX: { type: "spring", stiffness: 300, damping: 30, duration: 3 },
            translateY: { type: "spring", stiffness: 300, damping: 30, duration: 3 },
            opacity: { duration: 0.5 }
          }}
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
        >
          <div className="imageWrapper">
            <Image src={items[index]?.image?.url} width={1200}
                             height={600}
                             layout="raw" />
          </div>

          <h3 className="title">
            {items[index]?.title}
          </h3>


          {(isPayroll && index == 1) ? (
            <p className="quote"> {items[index]?.quote.slice(0, 46)} <br />{items[index]?.quote.slice(46)} </p>) :

            <p className="quote">{items[index]?.quote} </p>}


          <div className="attribution">
            {items[index]?.attribution}
          </div>
          <div className="stars">
            <img src="/static/images/icons/five-star-img.png" alt="stars" width="200px" height="200px" />
          </div>

        </motion.div>
      </AnimatePresence>
      <div id="testimonial-small-business" />
      <div className="slider-button-group">
        {items.map((item, itemIndex) =>
          <div key={itemIndex} onClick={() => changeIndex(itemIndex)} className={itemIndex === index ? 'active' : ''} />)}
      </div>
    </TestimonialsStyles>
  );
};


Testimonials.propTypes = {

  items: PropTypes.array.isRequired,
};

export default Testimonials;
